import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { Bundesland } from '@chancenwerk/enums/enums.js';
import { html } from 'lit';

@Entity()
export class BundeslandAspect extends AbstractAspect {
  static override _class = 'BundeslandAspect';

  @Field(() => String) value: Maybe<string>;

  constructor(doc: PartialEntityData<BundeslandAspect>) {
    super(doc);
  }

  override getMongoFilter(): object | null {
    if (!this.fieldName || !this.value) return null;
    return {
      [this.fieldName]: this.value,
    };
  }
}

export const BundeslandAspectSchema: AspectConfig<BundeslandAspect> = {
  aspectConstructor: BundeslandAspect,
  renderEditor: ({ aspectValue }) => {
    if (aspectValue.value && !Object.values(Bundesland).some(b => b === aspectValue.value)) {
      aspectValue.value = null;
    }
    return html`
      <cr-dropdown-search-selection
        clearable
        placeholder-mode="hide"
        .value=${aspectValue.value}
        .search=${(s: Maybe<string>) => {
          const states = Object.values(Bundesland);
          if (!s) return states;

          return states.filter(state => state.toLocaleLowerCase().includes(s.toLocaleLowerCase()));
        }}
        @value-picked=${(e: ValueEvent<Maybe<string>>) => {
          aspectValue.value = e.detail.value;
        }}
      ></cr-dropdown-search-selection>
    `;
  },
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
